import axios from "axios";

const getSupplementaryCateringTypes = async (venueId = "", token) => {
  try {
    const response = await axios.get(
      `${window.API}/rfp/supplement-type/${venueId}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (!response.data.data) {
      return {
        result: [],
      };
    }

    return {
      result: response.data.data.map(type => ({
        text: type.type,
        value: type.id,
      })),
    };
  } catch (error) {
    return { error, result: [] };
  }
};

const addSupplementaryCateringType = async ({ venueId, type }, token) => {
  try {
    const response = await axios.post(
      `${window.API}/rfp/supplement-type`,
      {
        venue_id: venueId,
        type,
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    if (!response.data.data) {
      return {
        result: [],
      };
    }
    return {
      text: response.data.data.type,
      value: response.data.data.id,
    };
  } catch (error) {
    return { error, result: false };
  }
};

export { getSupplementaryCateringTypes, addSupplementaryCateringType };
